export class CreateFleetUserDialogData {
    customerId?: string;
    fleetKindList?: string[];
}